import React, {useState} from 'react';
import DynaModal from "../../Modal/DynaModal";
import DynaTable from "../../MyTable/DynaTable";
import {toast} from "react-toastify";
import numericFunction from "../../../utils/NumericFunction";

const ModalSmsAddIf = ({onClose, ifData}) => {

    const [fieldType, setFieldType] = useState([{id: "number"}])
    const [sendData, setSendData] = useState([])
    const [onRowData, setOnRowData] = useState({})

    const column = [
        {
            "field": "fieldName",
            "title": "نام فیلد",
            "headerFilter": true
        },
        {
            "field": "amalGar",
            "title": "عملگر",
            "headerFilter": true
        },
        {
            "field": "valueText",
            "title": "مقدار",
            "headerFilter": true
        },
        {
            "field": "typeIf",
            "title": "نوع شرط",
            "headerFilter": true
        },
    ]

    const addDataToTableHandler = () => {

        if (Object.keys(onRowData).length > 3) {
            if (onRowData.typeIf !== ""){
                let temp = [...sendData]
                temp.push(onRowData)
                setSendData(temp)
                setOnRowData({...onRowData , typeIf:""})
                document.getElementsByName("U1")[0].checked = false
                document.getElementsByName("U1")[1].checked = false
                document.getElementsByName("U1")[2].checked = false
            }else{
                toast.error("موارد ضروری را پر کنید")
            }
        } else {
            toast.error("موارد ضروری را پر کنید")
        }

    }

    return (
        <DynaModal onClose={onClose} className={'modal-sms-panel'}>
            <div className="header-modal">
                <p>افزودن شرط</p>

                <div onClick={onClose}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M9.16936 15.5801C8.97936 15.5801 8.78938 15.5101 8.63938 15.3601C8.34938 15.0701 8.34938 14.5901 8.63938 14.3001L14.2994 8.64011C14.5894 8.35011 15.0694 8.35011 15.3594 8.64011C15.6494 8.93011 15.6494 9.41011 15.3594 9.70011L9.69936 15.3601C9.55936 15.5101 9.35936 15.5801 9.16936 15.5801Z"
                            fill="#EB455F"/>
                        <path
                            d="M14.8294 15.5801C14.6394 15.5801 14.4494 15.5101 14.2994 15.3601L8.63938 9.70011C8.34938 9.41011 8.34938 8.93011 8.63938 8.64011C8.92937 8.35011 9.40936 8.35011 9.69936 8.64011L15.3594 14.3001C15.6494 14.5901 15.6494 15.0701 15.3594 15.3601C15.2094 15.5101 15.0194 15.5801 14.8294 15.5801Z"
                            fill="#EB455F"/>
                        <path
                            d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
                            fill="#EB455F"/>
                    </svg>
                </div>
            </div>

            <div className="content-modal">

                <div className="form-side">

                    <div className="label-on-line">
                        <label>انتخاب فیلد</label>
                        <select className={"box-type-if"} onChange={(e) => {
                            setFieldType(document.getElementsByName(e.target.value))
                            const filtered = ifData.filter((item) => {
                                if (item.value === e.target.value) {
                                    setOnRowData({...onRowData, fieldName: item.label})
                                }
                            })
                        }}>
                            <option value="">انتخاب کنید</option>
                            {ifData.map((v, index) =>
                                <option name={v.value} id={v.type} key={"O" + index}
                                        value={v.value}>{v.label}</option>
                            )}
                        </select>
                    </div>

                    <div className="label-on-line">
                        <label>عملگر</label>
                        <select
                            className="box-type-if"
                            onChange={e => setOnRowData({...onRowData, amalGar: e.target.value})}
                            // value={row.operator}
                        >
                            <option value="">انتخاب کنید</option>
                            <option value=">">بزرگتر</option>
                            <option value=">=">بزرگتر مساوی</option>
                            <option value="=">مساوی</option>
                            <option value="!=">مخالف</option>
                            <option value="<">کوچیکتر</option>
                            <option value="<=">کوچیکتر مساوی</option>
                        </select>
                    </div>

                    <div className="label-on-line">
                        <label>مقدار</label>
                        {fieldType[0].id === "number" ?
                            <input value={numericFunction.e2p(onRowData.valueText)} onChange={(e) => setOnRowData({...onRowData, valueText: numericFunction.p2e(e.target.value)})}
                                   className={"box-type-if"} type={"number"}/> :
                            fieldType[0].id === "string" ?
                                <input onChange={(e) => setOnRowData({...onRowData, valueText: e.target.value})}
                                       className="box-type-if" type={"string"}/> : ""
                        }
                    </div>

                    <div className="label-on-line">
                        <label>نوع شرط</label>
                        <div className="box-type-if">

                            {sendData.length === 0 ?
                                <div className={"inline-radio"}>
                                    <input value={"هیچکدام"}
                                           onChange={(e) => setOnRowData({...onRowData, typeIf: e.target.value})}
                                           type="radio" id={"R1"} name="U1"/>
                                    <label htmlFor={"R1"} id={"R1"}>
                                        {"هیچکدام"}
                                    </label>
                                </div> :
                                <div className={"inline-radio light-label"}>
                                    <input value={"هیچکدام"}
                                           disabled={true}
                                           onChange={(e) => setOnRowData({...onRowData, typeIf: e.target.value})}
                                           type="radio" id={"R1"} name="U1"/>
                                    <label htmlFor={"R1"} id={"R1"}>
                                        {"هیچکدام"}
                                    </label>
                                </div>
                            }

                            {sendData.length > 0 ?
                                <>
                                    <div className={"inline-radio"}>
                                        <input value={"و"}
                                               onChange={(e) => setOnRowData({...onRowData, typeIf: e.target.value})}
                                               type="radio" id={"R2"} name="U1"/>
                                        <label htmlFor={"R2"} id={"R2"}>
                                            {"و"}
                                        </label>
                                    </div>

                                    <div className={"inline-radio"}>
                                        <input value={"یا"}
                                               onChange={(e) => setOnRowData({...onRowData, typeIf: e.target.value})}
                                               type="radio" id={"R3"} name="U1"/>
                                        <label htmlFor={"R3"} id={"R3"}>
                                            {"یا"}
                                        </label>
                                    </div>
                                </> :
                                <>
                                    <div className={"inline-radio light-label"}>
                                        <input value={"و"}
                                               disabled={true}
                                               onChange={(e) => setOnRowData({...onRowData, typeIf: e.target.value})}
                                               type="radio" id={"R2"} name="U1"/>
                                        <label htmlFor={"R2"} id={"R2"}>
                                            {"و"}
                                        </label>
                                    </div>

                                    <div className={"inline-radio light-label"}>
                                        <input value={"یا"}
                                               disabled={true}
                                               onChange={(e) => setOnRowData({...onRowData, typeIf: e.target.value})}
                                               type="radio" id={"R3"} name="U1"/>
                                        <label htmlFor={"R3"} id={"R3"}>
                                            {"یا"}
                                        </label>
                                    </div>

                                </>}
                        </div>
                    </div>
                </div>

                <div className="add-to-table">
                    <button onClick={addDataToTableHandler}>افزودن به جدول</button>
                </div>

                <div className="table-side">
                    {sendData.length > 0 && (
                        <DynaTable
                            column={column}
                            data={sendData}
                            className={"solid-table"}
                            onRowClick={""}
                            mainWidth={"100%"}
                        />
                    )}
                </div>

            </div>

            <div className="button-modal">
                <button className="accept-saden-modal" onClick={() => console.log(sendData)}>ثبت</button>
                <button onClick={onClose} className="cancel-saden-modal">انصراف</button>
            </div>
        </DynaModal>
    )
};

export default ModalSmsAddIf;